/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import {Component} from 'preact';

import PropTypes from 'prop-types';
import AudioVolumeVisualization from '../audioVolumeMeter/AudioVolumeVisualization';
import AudioSpeakerDetector from '../audioVolumeMeter/AudioSpeakerDetector';
import AudioPreview from '../components/AudioPreview';
import colors from '../styles/colors.css';
import {select} from 'd3-selection';

class AudioContainer extends Component {
  constructor(props) {
    super(props);
    this.audioVolumeMeterInit = this.audioVolumeMeterInit.bind(this);
  }

  audioVolumeMeterInit() {
    if (!this.props.mediaStream) {
      return;
    }

    const stream = this.props.mediaStream;

    this.audioSpeakingDetector = new AudioSpeakerDetector([stream]);
    this.audioVolumeMeter = this.audioSpeakingDetector.getAudioVolumeMeter(stream);
    this.audioVolumeVisualization = new AudioVolumeVisualization();
    this.audioVolumeVisualization.startRender(this.audioVolumeMeter, 'gain', {
      element: '#audioSelectPreview',
      title: 'Microphone Volume',
      textColors: colors,
      barColor: colors.bar
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mediaStream !== this.props.mediaStream) {
      if (prevProps.mediaStream) {
        disposeOfAudioContext.call(this);

        const audioTrack = prevProps.mediaStream.getAudioTracks()[0];

        if (audioTrack) {
          audioTrack.stop();
          prevProps.mediaStream.removeTrack(audioTrack);
        }
      }

      if (this.props.mediaStream) {
        this.audioVolumeMeterInit();
      }
    } else if (this.props.mediaStream === null) {
      this.audioVolumeMeterInit();
    }
  }

  componentWillUnmount() {
    disposeOfAudioContext.call(this);
  }

  render() {
    const propsStyle = this.props.propsStyle || {};

    return (
      <AudioPreview
        propsStyle={propsStyle} />
    );
  }
}

AudioContainer.propTypes = {
  propsStyle: PropTypes.object,
  mediaStream: PropTypes.object
};

function disposeOfAudioContext() {
  if (this.audioVolumeVisualization) {
    this.audioVolumeVisualization.stopRender();
  }

  if (this.audioSpeakingDetector) {
    this.audioSpeakingDetector.stop();
    this.audioSpeakingDetector.dispose();
  }

  select('#audioSelectPreview').selectAll('*').remove();
}

export default AudioContainer;